import React from 'react'

export default function Buttons(props) {
    let button = props.part_buttons;
    let buttons_position = '';

    switch (button['position']) {
        case 'start':
            buttons_position = 'button-block--start';
            break;
        case 'end':
            buttons_position = 'button-block--end';
            break;
        case 'center':
            buttons_position = 'button-block--center';
            break;
        default:
            buttons_position = 'button-block--center';
            break;
    }
    
    return (
        <div className={`button-block ${buttons_position}`}>
            {
                button.buttons && button.buttons.map((item,key) => {
                    if(item['link']) {
                        let target = '';
                        if (item['link'].startsWith('http://') ||
                        item['link'].startsWith('https://')) {
                            target = 'target="_blank"';
                        }
                        return (
                            <a key={`button-${key}`} className={`button button--border button--ft-${item['ft_color']} button--bg-${item['bg_color']} button--border-${item['border_color']} button--ft-hov-${item['ft_hov_color']} button--bg-hov-${item['bg_hov_color']} button--border-hov-${item['border_hov_color']}`} href={item['link']} target={target && target}>
                                <span>{item['text']}</span>
                            </a>
                        )
                    } else {
                        return null;
                    }
                })
            }
            
        </div>
    )
}

